import { withNamespace } from "@/i18n/lazy-route"

/** The application settings (LLD §9.25, Task 6.5), with the `adminSettings` namespace. */
const translations = {
  en: () => import("@/i18n/locales/en/adminSettings.json"),
  fr: () => import("@/i18n/locales/fr/adminSettings.json"),
}

export const SettingsScreen = withNamespace(
  "adminSettings",
  () => import("./screens/SettingsScreen"),
  translations,
)
export const SettingScreen = withNamespace(
  "adminSettings",
  () => import("./screens/SettingScreen"),
  translations,
)
